export const LAB_ID = 8;

export { CHAT_MESSAGES, PREDATA_POINTS } from "./messages";

// navigation routes
export const NAV_BIASED_SIMULATION = "/Lab8/Exercise/BiasedSimulation";
